export default __webpack_public_path__ + "static/media/Kerkyra.5df055f2.jpg";